import { createFileRoute } from '@tanstack/react-router';
import LearningPathChat from '@/components/Learn/LearningPathChat';

export const Route = createFileRoute('/_auth/chat')({
  validateSearch: (search: Record<string, unknown>): { q?: string; doc?: string } => {
    const result: { q?: string; doc?: string } = {};
    if (typeof search.q === 'string' && search.q.length > 0) result.q = search.q;
    if (typeof search.doc === 'string' && search.doc.length > 0) result.doc = search.doc;
    return result;
  },
  component: GeneratePage,
});

function GeneratePage() {
  const { q, doc } = Route.useSearch();

  return <LearningPathChat initialPrompt={q} documentId={doc} />;
}
